import { render } from "./TextStyle.vue?vue&type=template&id=01962344&scoped=true"
import script from "./TextStyle.vue?vue&type=script&lang=js"
export * from "./TextStyle.vue?vue&type=script&lang=js"

import "./TextStyle.vue?vue&type=style&index=0&id=01962344&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01962344"]])

export default __exports__